import { useContext, useState } from "react";
import { ModalContext } from "../../../utils/modal/ModalProvider";
import { containsXss } from "../../../utils/security/XssFilter";
import { DialogEnum, showDialog } from "../../../utils/dialog/Dialog";
import { IAM_PATH, IAM_SERVER_SERVICE_USER } from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import styles from '../../../utils/modal/DetailModal.module.css';
import { ADMINROLE } from "../ServiceUser";
import { isEmailSimple } from "../../../utils/modal/ValidEmail";


export const ADMINROLE_LABEL = {
    SYS_ADMIN: '시스템 관리자',
    ADMIN_USER: '계정 관리자'
};

/**
 * 사용자 등록 모달 Container
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const ServiceUserRegisterModal = ({ update, idToNameMap }) => {

    const { closeModal } = useContext(ModalContext);
    const [isNull, setIsNull] = useState(false); //빈 값 확인

    const [formData, setFormData] = useState({
        userId: '',
        password: '',
        passwordConfirm: '',
        userName: '',
        email: '',
        phone: '',
        groupId: '0',
        role: '',
        status: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    // 사용자 등록 요청 API
    const handleRegister = () => {
        if (formData.role === ADMINROLE.SYS_ADMIN) {
            formData.groupId = '0';
        }

        for (let key in formData) {
            if (key === 'email') {
                console.log("12412414124");
                if (!isEmailSimple(formData[key])) {
                    showDialog(DialogEnum.DEFAULT, "경고", "올바른 이메일을 입력해 주세요.");
                    // setIsNull(true);
                    return;
                }
            }

            // if (formData[key] === ''|| formData[key] === '0') {
            if (formData[key] === '') {
                setIsNull(true);
                return;
            } else if (containsXss(formData[key])) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }))
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            }
        }
        setIsNull(false);
        // addUser();

        if (formData.password === formData.passwordConfirm) {
            const params = Object.assign({}, formData);
            params.status = params.status === 'true'
            delete params.passwordConfirm;

            const url = `${IAM_PATH}${IAM_SERVER_SERVICE_USER}/create`;
            axios.post(url, params)
                .then((res) => {
                    if (res.data.code == 200) {
                        showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                        update();
                    } else {
                        showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                    }
                })
                .catch((e) => {
                    showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
                });
        } else {
            showDialog(DialogEnum.DEFAULT, "경고", "비밀번호가 일치하지 않습니다.");
        }
    }

    return (
        <div>
            <ul className={styles.layer__listWrap}>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>아이디</p>
                    <input className={styles.layer__listInput}
                        type={"text"}
                        name={"userId"}
                        value={formData.userId}
                        onChange={handleChange} />
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>비밀번호</p>
                    <input className={styles.layer__listInput}
                        type={"password"}
                        name={"password"}
                        value={formData.password}
                        onChange={handleChange} />
                </li>
                <li className={styles.layer__list}>
                    <p lang={"ko"} className={styles.layer__listTit}>비밀번호 확인</p>
                    <input className={styles.layer__listInput}
                        type={"password"}
                        name={"passwordConfirm"}
                        value={formData.passwordConfirm}
                        onChange={handleChange} />
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>이름</p>
                    <input className={styles.layer__listInput}
                        type={"text"}
                        name={"userName"}
                        value={formData.userName}
                        onChange={handleChange} />
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>전화번호</p>
                    <input className={styles.layer__listInput}
                        type={"text"}
                        name={"phone"}
                        value={formData.phone}
                        onChange={handleChange} />
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>이메일</p>
                    <input className={styles.layer__listInput}
                        type={"text"}
                        name={"email"}
                        value={formData.email}
                        onChange={handleChange} />
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>권한</p>
                    <select
                        className={styles.layer__listInput}
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                    >
                        <option value={""}>{":: 권한을 선택하세요 ::"}</option>
                        {/* {Object.entries(ADMINROLE).map(([id, name]) => (
                            <option key={id} value={id}>
                                {name}
                            </option>
                        ))} */}
                        {Object.entries(ADMINROLE).map(([id]) => (
                            <option key={id} value={id}>
                                {ADMINROLE_LABEL[id]}
                            </option>
                        ))}
                    </select>
                </li>
                {formData.role !== ADMINROLE.SYS_ADMIN && (
                    <li className={styles.layer__list}>
                        <p className={styles.layer__listTit}>그룹명</p>
                        <select
                            className={styles.layer__listInput}
                            name="groupId"
                            value={formData.groupId}
                            onChange={handleChange}
                        >
                            <option value={"0"}>{":: 관리할 그룹을 선택하세요 ::"}</option>
                            {Object.entries(idToNameMap).map(([id, name]) => (
                                <option key={id} value={id}>
                                    {name}
                                </option>
                            ))}
                        </select>
                    </li>
                )}
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>상태</p>
                    <select
                        className={styles.layer__listInput}
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                    >
                        <option value={""}>{"선택"}</option>
                        <option value={"false"}>{"비활성화"}</option>
                        <option value={"true"}>{"활성화"}</option>
                    </select>
                </li>
            </ul>

            {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null}
            <button className={styles.layer__saveBtn} onClick={handleRegister}>등록</button>
        </div>
    )
}